module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House35.5b98a4d7.jpg";